import { Component, inject } from '@angular/core';
import { I18nService } from '@digilize/shared/feature/modules/i18n/src';

import { GtmService } from './services/gtm.service';

@Component({
  selector: 'bwc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private readonly i18nService = inject(I18nService);
  private readonly gtmService = inject(GtmService);

  constructor() {
    this.i18nService.init();
    this.gtmService.init();
  }
}
